module.exports = __webpack_public_path__ + "8603ebed74704461b986eda6beb03e91.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/prologis_2021_chart.png
// module id = 1711
// module chunks = 0